import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { ImageElement, ImageElementAttributes } from "../Components/Elements/Graphics/ImageElement";
import { ImageTextElement } from "../Components/Elements/Texts/ImageTextElement";
import { StageController } from "../Components/StageController";
import { ChipConfiguration } from "../CustomComponents/ChipConfiguration";
import { BetManager } from "../Managers/BetManager";
import { CustomUtils } from "../Utils/CustomUtils";

@engineComponent(ComponentTypes.DisplayObject)
export class Chip extends ContainerElement {
    private _baseElement: ImageElement;
    private _valueElement: ImageTextElement;

    constructor() {
        super();
    }

    createByNode(node: Element): void {
        super.createByNode(node);

        if (this.childs["Base"]) {
            this._baseElement = <ImageElement>this.childs["Base"];
        }

        if (this.childs["Value"]) {
            this._valueElement = <ImageTextElement>this.childs["Value"];
        }
    }

    public setupChip(index: number, value: number): void {
        if (this._baseElement) {
            //ToDo zmazat podmienku
            if (PIXI.utils.TextureCache["GFX_chip_" + index] == null) {
                index = 0;
            }

            let chipIndex = ChipConfiguration.colors[BetManager.Chips.length][index];
            this._baseElement.texture = StageController.getTextureByResourceId("GFX_chip_" + chipIndex);
        }

        if (this._valueElement) {
            this._valueElement.bitmapText.text = CustomUtils.abbreviateNumber(value);
            this._valueElement.realign();
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Chip.ts
 **/